class ProductSection extends HTMLElement {
    constructor() {
        super();

        this.productVariants = this.querySelector('#product-variants');
        this.variantWrappers = this.productVariants.querySelectorAll('.variant-wrapper');
        this.variantFieldsets = this.productVariants.querySelectorAll('fieldset');
        // Only Shopify option radios inside fieldsets — exclude Colour metafield radios
        this.radioBtns = this.productVariants.querySelectorAll('fieldset input[type="radio"]');
        this.masterVariantFields = this.querySelectorAll('.product-wrapper form[action*="/cart/add"] input[name="id"]');
        this.cartBtn = this.querySelectorAll('.product-wrapper form[action*="/cart/add"] button[type="submit"]');
        this.cartBtnText = this.querySelectorAll('.product-wrapper form[action*="/cart/add"] button[type="submit"] .btn-add-to-cart-text');

        this.productPrice = this.querySelector('.product-wrapper .js-product-price');
        this.productPriceButton = this.querySelectorAll('.btn-add-to-cart .js-product-price');
        this.productPriceText = this.querySelector('.product-wrapper .js-product-price .price');
        this.saveNow = this.querySelector('.product-wrapper .js-product-price .price-now');
        this.productCAP = this.querySelector('.product-wrapper .js-product-compare-at-price');
        this.saveIndication = this.querySelector('.product-wrapper .save-indication');
        this.saveAmountPercentage = this.querySelector('.product-wrapper .save-amount-percentage');
        this.selectedMattressUpsell = this.querySelector('.selected-mattress-upsell');
        this.selectedHeadboardUpsell = this.querySelector('.selected-headboard-upsell');

        this.isProductPage = document.body.classList.contains('template-product') ? true : false;
        this.isSingleVariant = this.querySelector('.single-variant') ? true : false;

        this.tooltips = this.querySelectorAll('.colour-tooltip');
        this.colourRadios = this.querySelectorAll(".product-colour-option-wrapper input[name='Colour']");

        this.detailElements = this.querySelectorAll(
            '.product-options .product-option-wrapper > details',
        );

        // Cache DOM queries for upsell popups
        this.upsellPopups = null;

        // Cache parsed variant JSON (cleared if section DOM is replaced)
        this._variantData = null;

        // Debounce variant updates (timer; does not need rAF)
        this._variantUpdateTimeoutId = null;

        // Debounce timeout for URL updates
        this._urlUpdateTimeout = null;
    }

    connectedCallback() {
        this.initListeners();
    }

    initListeners() {
        this.productVariants.addEventListener('change', this.handleVariantChange.bind(this));
        this.addEventListener('click', this.handleSizeInfoClick.bind(this));

        if (!this.isSingleVariant) {
            this.updateProductVariants();
        }

        this.tooltips.forEach((tooltip) => {
            const parent = tooltip.closest('.accordion-colour-swatch');

            parent.addEventListener('mouseenter', this.checkAlignment.bind(this, parent, tooltip));
            parent.addEventListener('focus', this.checkAlignment.bind(this, parent, tooltip));
        });

        // Add change event listener to each radio button
        this.colourRadios.forEach((radio) => {
            radio.addEventListener('change', (e) => {
                if (e.target.checked) {
                    this.updateColourOptionInUrl(e.target.value);
                    this.updateColourProperties(e.target.value);
                    this.updateSelectedColour(e.target.value, e.target.dataset.value);
                    this.updateHeadBoardColorVariants(e.target.value);
                    /* New feature - headboard master image update with metafield image */
                    this.updateMasterProductImage(e.target.value);
                }
            });
        });

        this.detailElements.forEach(detail => {
            detail.addEventListener('click', this.handleDetailClick.bind(this));
        });

        this.initColourFromUrl();
        this.updateStickySelectedOptions();
    }

    initColourFromUrl() {
        if (!this.isProductPage || this.closest('.product-quick-view-content')) return;

        const swatchParam = new URL(window.location.href).searchParams.get('swatch');
        if (!swatchParam) return;

        const colourSwatchWrapper = this.querySelector('.colour-swatch-wrapper');
        if (!colourSwatchWrapper) return;

        const matchingRadio = Array.from(
            colourSwatchWrapper.querySelectorAll("input[name='Colour']")
        ).find(radio =>
            radio.value === swatchParam ||
            radio.value.toLowerCase() === swatchParam.toLowerCase()
        );

        if (!matchingRadio || matchingRadio.checked) return;

        matchingRadio.checked = true;
        matchingRadio.dispatchEvent(new Event('change', { bubbles: true }));
    }

    updateColourOptionInUrl(value){
        const url = new URL(window.location.href);
        url.searchParams.set('swatch', value);
        window.history.replaceState({}, '', url.toString());
    }
    updateMasterProductImage(value){
        const masterProductColorVariants = window.masterProductColorVariants;
        if (masterProductColorVariants) {
            const selectedColorVariant = masterProductColorVariants.find(colorVariant => colorVariant.colour_name === value);
            const custom_image_property = this.querySelector("input.custom-image-property");
            const defaultImage = custom_image_property.getAttribute("data-default-value");
            const first_slide_image = this.querySelector("product-carousel .carousel__slide:first-child img");
            const lightbox_image = this.querySelector(".lightbox-image img");
            if (selectedColorVariant && selectedColorVariant.colour_image != "") {
                first_slide_image.src = selectedColorVariant.colour_image;
                first_slide_image.srcset = selectedColorVariant.colour_image;
                lightbox_image.src = selectedColorVariant.colour_image;
                lightbox_image.srcset = selectedColorVariant.colour_image;
                /* update the custom image property */
                if (custom_image_property){
                    custom_image_property.value = selectedColorVariant.colour_image;
                }
            } else {
                first_slide_image.src = defaultImage;
                first_slide_image.srcset = defaultImage;
                lightbox_image.src = defaultImage;
                lightbox_image.srcset = defaultImage;
                /* update the custom image property */
                if (custom_image_property){
                    custom_image_property.value = defaultImage;
                }
            }
        }
    }

    handleDetailClick(e) {
        if (e.target.closest('.size-option-info-trigger')) return;

        const detail = e.target.closest('details');
        if (!detail || detail.hasAttribute('open')) return;

        // Click opens this row after the event; close the others first
        this.detailElements.forEach((otherDetail) => {
            if (otherDetail !== detail) {
                otherDetail.removeAttribute('open');
            }
        });
    }

    // Function to update inputs with class 'colour-property'
    updateColourProperties(value) {
        // Batch DOM reads - get all elements first
        const colourProperties = this.querySelectorAll('.colour-property');
        // Batch DOM writes - update all at once to avoid multiple reflows
        for (let i = 0; i < colourProperties.length; i++) {
            colourProperties[i].value = value;
        }
    }
    updateHeadBoardColorVariants(value){
        if (this.querySelectorAll('.headboard-upsell button.upsell-product').length > 0) {
            this.querySelectorAll('.headboard-upsell button.upsell-product').forEach(headboard => {
                const headboardId = headboard.getAttribute('popovertarget').split('product-upsell-popup-')[1];
                document.querySelector(`.product-upsell-popup[id="product-upsell-popup-${headboardId}"]`).setAttribute('data-colour-variant', value);
                headboard.querySelector('.upsell-product-option').textContent = `Fabric Colour: ${value}`;

                const headboardColorVariants = window[`headBoardColorVariants_${headboardId}`];
                if (headboardColorVariants) {
                    const selectedColorVariant = headboardColorVariants.find(colorVariant => colorVariant.colour_name === value);
                    if (selectedColorVariant) {
                        headboard.querySelectorAll('.upsell-product-image img').forEach(img => {
                            if (selectedColorVariant.colour_image) {
                                img.src = selectedColorVariant.colour_image;
                                img.srcset = selectedColorVariant.colour_image;
                            } else {
                                const default_image = img.getAttribute('datadefaultimage');
                                img.src = default_image;
                                img.srcset = default_image;
                            }
                        });
                        document.querySelector(`.product-upsell-popup[id="product-upsell-popup-${headboardId}"]`).setAttribute('data-colour-variant', selectedColorVariant.colour_name);
                        if (selectedColorVariant.colour_image) {
                            document.querySelector(`.product-upsell-popup[id="product-upsell-popup-${headboardId}"] img`).src = selectedColorVariant.colour_image;
                            document.querySelector(`.product-upsell-popup[id="product-upsell-popup-${headboardId}"] img`).srcset = selectedColorVariant.colour_image;
                        } else {
                            const default_image = document.querySelector(`.product-upsell-popup[id="product-upsell-popup-${headboardId}"] img`).getAttribute('datadefaultimage');
                            document.querySelector(`.product-upsell-popup[id="product-upsell-popup-${headboardId}"] img`).src = default_image;
                            document.querySelector(`.product-upsell-popup[id="product-upsell-popup-${headboardId}"] img`).srcset = default_image;
                        }
                    } else {
                        headboard.querySelectorAll('.upsell-product-image img').forEach(img => {
                            const default_image = img.getAttribute('datadefaultimage');
                            img.src = default_image;
                            img.srcset = default_image;
                        });                        
                        const default_image = document.querySelector(`.product-upsell-popup[id="product-upsell-popup-${headboardId}"] img`).getAttribute('datadefaultimage');
                        document.querySelector(`.product-upsell-popup[id="product-upsell-popup-${headboardId}"] img`).src = default_image;
                        document.querySelector(`.product-upsell-popup[id="product-upsell-popup-${headboardId}"] img`).srcset = default_image;
                    }
                }
            });                
        }
    }
    updateSelectedColour(value, className) {
        // Batch DOM reads - get wrapper once, then query children
        const wrapper = this.querySelector('.product-colour-option-wrapper');
        if (!wrapper) return;

        const selectedOption = wrapper.querySelector('.selected-option');
        const selectedIcon = wrapper.querySelector('.selected-icon');

        if (!selectedOption || !selectedIcon) return;

        // Batch DOM writes - use single className assignment instead of multiple operations
        // This avoids multiple style recalculations
        selectedOption.textContent = value;
        selectedIcon.className = 'selected-icon ' + className;

        this.updateStickySelectedOptions();
    }

    /**
     * Syncs sticky ATC selected-options line with current PDP option summaries.
     */
    updateStickySelectedOptions() {
        const stickyOptions = document.querySelector('.js-sticky-selected-options');
        if (!stickyOptions) return;

        const wrappers = this.querySelectorAll(
            '.product-options .product-option-wrapper:not(.mattress-upsell):not(.headboard-upsell):not(.selected-mattress-upsell):not(.selected-headboard-upsell)'
        );

        // Keep Liquid-rendered options when PDP option UI is not present
        if (!wrappers.length) return;

        const parts = [];

        wrappers.forEach((wrapper) => {
            const selected = wrapper.querySelector('summary .selected-option');
            if (!selected) return;

            let text = selected.textContent.trim();
            if (!text) return;

            const dims = wrapper.querySelector('summary .selected-option-dims');
            if (dims && !dims.hidden) {
                const dimsText = dims.textContent.replace(/[()]/g, '').trim();
                if (dimsText) {
                    text = `${text} ${dimsText}`;
                }
            }

            parts.push(text);
        });

        if (parts.length === 0) {
            stickyOptions.textContent = '';
            stickyOptions.hidden = true;
            return;
        }

        stickyOptions.textContent = parts.join(' • ');
        stickyOptions.hidden = false;
    }

    checkAlignment(parent, tooltip) {
        const parentRect = parent.getBoundingClientRect();
        const tooltipWidth =
            tooltip.offsetWidth || parseFloat(getComputedStyle(tooltip).width) || 0;

        // Reset alignment first
        tooltip.classList.remove('align-right');

        // Mobile layout viewport grows with overflow, so measure against the grid
        const swatchGrid = parent.closest('.colour-swatch-wrapper');
        const boundaryRight = swatchGrid
            ? swatchGrid.getBoundingClientRect().right
            : document.documentElement.clientWidth;

        // If tooltip overflows right, align it to the left
        if (parentRect.left + tooltipWidth > boundaryRight) {
            tooltip.classList.add('align-right');
        }
    }

    handleVariantChange(e) {
        if (e.target.type === 'radio') {
            const fieldset = e.target.closest('.product-option-wrapper');
            const summary = fieldset.querySelector('summary');
            const selectedIcon = summary.querySelector('.selected-icon');
            const selectedOption = summary.querySelector('.selected-option');
            const selectedOptionDims = summary.querySelector('.selected-option-dims');
            const selectedLabel = e.target.nextElementSibling;

            // Update selected option text
            if (selectedOption) {
                const optionText = selectedLabel.querySelector('.variant-label');
                if (optionText) {
                    selectedOption.textContent = optionText.textContent;
                }
            }

            if (selectedOptionDims) {
                const dimsText = selectedLabel.dataset.optionDims
                    || selectedLabel.querySelector('.js-size-option-dims')?.textContent?.trim()
                    || '';

                if (dimsText) {
                    selectedOptionDims.textContent = `(${dimsText})`;
                    selectedOptionDims.hidden = false;
                } else {
                    selectedOptionDims.textContent = '';
                    selectedOptionDims.hidden = true;
                }
            }

            // Update selected icon
            if (selectedIcon) {
                const labelImg = selectedLabel.querySelector('img');
                const iconUrl = selectedLabel.dataset.iconUrl;

                if (labelImg) {
                    selectedIcon.innerHTML = '';
                    const clonedImg = labelImg.cloneNode(true);
                    selectedIcon.appendChild(clonedImg);
                } else if (iconUrl) {
                    selectedIcon.innerHTML = '';
                    const img = document.createElement('img');
                    img.src = iconUrl;
                    img.alt = selectedLabel.dataset.labelValue || '';
                    img.loading = 'lazy';
                    selectedIcon.appendChild(img);
                } else {
                    selectedIcon.innerHTML = '';
                }
            }

            this.updateStickySelectedOptions();
        }
    }

    /**
     * Prevents option info icon clicks from toggling the option accordion.
     * @param {MouseEvent} event
     */
    handleSizeInfoClick(event) {
        const trigger = event.target.closest('.size-option-info-trigger');
        if (!trigger || !this.contains(trigger)) return;

        event.stopPropagation();
    }

    /**
     * Gets variant data from the JSON script tag (cached after first parse)
     * @returns {Array} Array of variant objects
     */
    getVariantData() {
        if (this._variantData != null) {
            return this._variantData;
        }
        const el = this.productVariants?.querySelector('[type="application/json"]');
        if (!el) return [];
        this._variantData = JSON.parse(el.textContent);
        return this._variantData;
    }

    /**
     * Updates the add to cart button state based on variant availability
     * @param {boolean} available - Whether the current variant is available
     * @param {boolean} [sync] - If true, update immediately; otherwise defer with rAF (for non-variant callers)
     */
    updateAddToCartButton(available, sync) {
        const run = () => {
            if (available) {
                this.cartBtn.forEach(btn => {
                    btn.classList.add('btn-primary');
                    btn.disabled = false;
                });
                this.cartBtnText.forEach(text => {
                    text.innerHTML = window.custom_product.addToCart;
                });
            } else {
                this.cartBtn.forEach(btn => {
                    btn.classList.remove('btn-primary');
                    btn.disabled = true;
                });
                this.cartBtnText.forEach(text => {
                    text.innerHTML = window.custom_product.soldOut;
                });
            }
        };
        if (sync) {
            run();
        } else {
            requestAnimationFrame(run);
        }
    }

    /**
     * Updates product pricing display including sale prices and savings
     * @param {Object|number} variantOrId - The selected variant object, or variant ID (legacy)
     * @param {boolean} [sync] - If true, update immediately (used from variant change path)
     */
    updateVariantPrice(variantOrId, sync) {
        const variantData = typeof variantOrId === 'object' ? variantOrId : this.getVariantData().find(v => v.id === variantOrId);
        if (!variantData) return;

        const run = () => {
            this.productPriceText.innerHTML = formatMoney(variantData.price, window.theme.moneyFormat);
            this.productPriceText.dataset.price = variantData.price;

            let total = variantData.price;
            if (this.selectedMattressUpsell && !this.selectedMattressUpsell.classList.contains('hidden')) {
                const mattressPrice = this.selectedMattressUpsell.getAttribute('data-price');
                const mattressQuantity = this.selectedMattressUpsell.getAttribute('data-variant-quantity');
                if (mattressPrice != null && mattressQuantity != null) {
                    total += Number(mattressPrice) * Number(mattressQuantity);
                }
            }
            if (this.selectedHeadboardUpsell && !this.selectedHeadboardUpsell.classList.contains('hidden')) {
                const headboardPrice = this.selectedHeadboardUpsell.getAttribute('data-price');
                const headboardQuantity = this.selectedHeadboardUpsell.getAttribute('data-variant-quantity');
                if (headboardPrice != null && headboardQuantity != null) {
                    total += Number(headboardPrice) * Number(headboardQuantity);
                }
            }
            this.productPriceButton.forEach(btn => {
                btn.innerHTML = formatMoney(total, window.theme.moneyFormat);
            });

            if (variantData.compare_at_price != null) {
                this.productPrice.classList.add('sale');
                this.productCAP.classList.remove('hidden');
                this.productCAP.innerHTML = formatMoney(variantData.compare_at_price, window.theme.moneyFormat);
                this.saveNow.classList.remove('hidden');
                this.saveIndication.classList.remove('hidden');
                if (this.saveAmountPercentage) {
                    this.saveAmountPercentage.textContent = `${Math.round((variantData.compare_at_price - variantData.price) / variantData.compare_at_price * 100)}`;
                }
            } else {
                this.productCAP.classList.add('hidden');
                this.saveIndication.classList.add('hidden');
                this.productPrice.classList.remove('sale');
                this.saveNow.classList.add('hidden');
            }

            this.updateSnapFinanceWidget(variantData.price);
        };
        if (sync) {
            run();
        } else {
            requestAnimationFrame(run);
        }
    }

    /**
     * Refreshes the Snap Finance RBP widget for the selected variant price.
     * @param {number} priceCents - Variant price in cents
     */
    updateSnapFinanceWidget(priceCents) {
        if (
            priceCents == null ||
            !window.theme?.snapFinanceWidget?.updatePdp
        ) {
            return;
        }

        window.theme.snapFinanceWidget.updatePdp(priceCents);
    }

    /**
    * Updates all product details for the selected variant
    * @param {Object} variant - The selected variant object
    */
    updateFinalVariant(variant) {
        this.masterVariantFields.forEach(field => {
            field.value = variant.id;
        });
        this.updateVariantPrice(variant, true);
        this.updateAddToCartButton(variant.available, true);

        // Update URL with variant parameter (debounced)
        if (this.isProductPage && !this.closest('.product-quick-view-content')) {
            this.debouncedUrlUpdate(variant.id);

            const variantSize = variant.option1;
            // Use cached upsell popups
            if (!this.upsellPopups) {
                this.upsellPopups = this.querySelectorAll('.product-upsell-popup');
            }
            const upsellPopups = this.upsellPopups;

            upsellPopups.forEach(popup => {
                const variantSelect = popup.querySelector('.upsell-select');

                if (variantSelect) {
                    let firstMatchFound = false;

                    Array.from(variantSelect.options).forEach((option) => {
                        if (option.text.toLowerCase().includes(variantSize.toLowerCase())) {
                            if (!firstMatchFound) {
                                option.selected = true;
                                variantSelect.dispatchEvent(new Event('change'));
                                firstMatchFound = true;
                            }
                        }
                    });
                }
            });

            document.querySelectorAll(
                'dimensions-section, product-dimension-tab'
            ).forEach(section => {
                section.dispatchEvent(new CustomEvent('dimension:variant:changed', {
                    detail: {
                        variant: variant
                    }
                }));
            });
            document.dispatchEvent(new CustomEvent('dimension:variant:changed', {
                detail: {
                    variant: variant
                }
            }));
        }
    };

    /**
     * Resolves one variant from selected option values (single pass, early exit).
     * @param {Array} allVariants - Full variant list
     * @param {Array} selectedOptions - Current option values
     * @returns {Object} Matched variant
     */
    findVariantForOptions(allVariants, selectedOptions) {
        let v = allVariants.find(variant =>
            selectedOptions.every((selectedValue, index) => {
                const key = `option${index + 1}`;
                return variant[key] === selectedValue;
            })
        );
        if (v) return v;
        v = allVariants.find(variant =>
            selectedOptions.every((selectedValue, index) => {
                const key = `option${index + 1}`;
                return variant[key] && variant[key].includes(selectedValue);
            })
        );
        if (v) return v;
        if (selectedOptions.length === 1) {
            v = allVariants.find(variant => variant.title === selectedOptions[0]);
            if (v) return v;
            v = allVariants.find(variant => variant.option1 === selectedOptions[0]);
            if (v) return v;
        }
        for (let i = 0; i < selectedOptions.length; i++) {
            const key = `option${i + 1}`;
            v = allVariants.find(variant => variant[key] === selectedOptions[i]);
            if (v) return v;
        }
        return allVariants.find(variant => variant.available) || allVariants[0];
    }

    /**
     * Updates price/compare-at on Size option cards for the current other-option selections.
     * @param {Array} selectedOptions - Currently selected option values by fieldset index
     * @param {Array} [allVariants] - Pre-fetched variant array
     */
    updateSizeOptionPrices(selectedOptions, allVariants) {
        const sizeFieldset = this.productVariants?.querySelector('.product-option-wrapper--size');
        if (!sizeFieldset) return;

        const variants = allVariants != null ? allVariants : this.getVariantData();
        const optionIndex = Number(sizeFieldset.dataset.optionIndex || 0);
        const labels = sizeFieldset.querySelectorAll('.js-size-option-label');

        labels.forEach((label) => {
            const sizeValue = label.getAttribute('data-label-value');
            if (!sizeValue) return;

            const testOptions = [...selectedOptions];
            testOptions[optionIndex] = sizeValue;

            const matchedVariant = this.findVariantForOptions(variants, testOptions);
            const priceEl = label.querySelector('.js-size-option-price');
            const compareEl = label.querySelector('.js-size-option-compare');

            if (!matchedVariant || !priceEl) return;

            priceEl.innerHTML = formatMoney(matchedVariant.price, window.theme.moneyFormat);

            if (
                compareEl
                && matchedVariant.compare_at_price != null
                && matchedVariant.compare_at_price > matchedVariant.price
            ) {
                compareEl.innerHTML = formatMoney(
                    matchedVariant.compare_at_price,
                    window.theme.moneyFormat,
                );
                compareEl.hidden = false;
            } else if (compareEl) {
                compareEl.innerHTML = '';
                compareEl.hidden = true;
            }
        });
    }

    /**
     * Returns checked Shopify option radios (fieldset only).
     * @returns {HTMLInputElement[]}
     */
    getCheckedOptionRadios() {
        return Array.from(
            this.productVariants.querySelectorAll('fieldset input[type="radio"]:checked')
        );
    }

    /**
     * Finds a variant label by its option value without CSS attribute selectors
     * (option names can contain quotes/apostrophes like 2'6).
     * @param {ParentNode} container
     * @param {string} value
     * @returns {Element|undefined}
     */
    findVariantLabel(container, value) {
        return Array.from(container.querySelectorAll('.js-variant-label')).find(
            (label) => label.getAttribute('data-label-value') === value
        );
    }

    /**
     * Filters variants based on selected options using exact matching
     * @param {Array} selectedOptions - Array of selected option values
     * @param {Array} [allVariants] - Pre-fetched variant array (avoids getVariantData when provided)
     * @returns {Array} Filtered variants that match the selected options
     */
    getAvailableOptionsForCombination(selectedOptions, allVariants) {
        let filteredVariants = allVariants != null ? allVariants : this.getVariantData();

        selectedOptions.forEach((selectedValue, index) => {
            if (selectedValue) {
                const optionKey = `option${index + 1}`;
                filteredVariants = filteredVariants.filter(v =>
                    v[optionKey] === selectedValue
                );
            }
        });

        return filteredVariants;
    };

    /**
     * Updates the availability of variant options based on current selections.
     * Only marks options that have no matching variant combination — sold-out
     * variants stay clickable so ATC can show the sold-out state.
     * @param {NodeList|HTMLInputElement[]} checkedBtns - Currently selected option radios
     * @param {Array} [allVariants] - Pre-fetched variant array (avoids getVariantData when provided)
     */
    updateRemainingOptions(checkedBtns, allVariants) {
        // Clear all unavailable states first
        this.productVariants.querySelectorAll('.js-unavailable-variant').forEach(label => label.classList.remove('js-unavailable-variant'));

        // Single-option products: every size exists as its own variant — never grey out
        if (this.variantFieldsets.length <= 1) {
            return;
        }

        const variants = allVariants != null ? allVariants : this.getVariantData();
        const selectedOptions = Array.from(checkedBtns).map(btn => btn.value);

        // For each fieldset, determine which options should be available
        this.variantFieldsets.forEach((fieldset, fieldsetIndex) => {
            const fieldsetLabels = fieldset.querySelectorAll('.js-variant-label');
            const allOptionsForThisFieldset = Array.from(fieldsetLabels).map(label => label.getAttribute('data-label-value'));

            // Check availability for each option in this fieldset
            allOptionsForThisFieldset.forEach(optionValue => {
                const testOptions = [...selectedOptions];
                testOptions[fieldsetIndex] = optionValue;
                const variantsWithThisOption = this.getAvailableOptionsForCombination(testOptions, variants);
                const isAvailable = variantsWithThisOption.length > 0;

                // Mark as unavailable if no variants exist for this combination
                if (!isAvailable) {
                    const label = this.findVariantLabel(fieldset, optionValue);

                    label && label.classList.add('js-unavailable-variant');
                }
            });
        });

        this.selectAvailableStorage();
    };

    /**
     * Unavailable storage options are hidden, so never leave one selected:
     * move the selection to the first storage option the size is sold with.
     */
    selectAvailableStorage() {
        const checked = this.productVariants.querySelector(
            '.product-option-wrapper--storage input[type="radio"]:checked'
        );
        if (!checked || !checked.nextElementSibling?.classList.contains('js-unavailable-variant')) return;

        const fallback = Array.from(
            checked.closest('.variant-wrapper').querySelectorAll('.js-variant-label')
        ).find(label => !label.classList.contains('js-unavailable-variant'));
        const input = fallback && document.getElementById(fallback.htmlFor);
        if (!input) return;

        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    /**
    * Main function to initialize and handle product variant selection
    * Supports single-option, two-option, and three-option products
    * Handles dynamic availability updates and price changes
    */
    updateProductVariants() {

        /**
         * Handles variant selection. Debounced with setTimeout (no rAF); coalesces rapid clicks.
         */
        this.radioBtns.forEach(radio => radio.addEventListener('change', () => {
            if (this._variantUpdateTimeoutId != null) {
                clearTimeout(this._variantUpdateTimeoutId);
            }
            this._variantUpdateTimeoutId = setTimeout(() => {
                this._variantUpdateTimeoutId = null;

                const radioBtnsChecked = this.getCheckedOptionRadios();
                const allVariants = this.getVariantData();
                const selectedOptions = radioBtnsChecked.map(btn => btn.value);

                const combineVariant = this.findVariantForOptions(allVariants, selectedOptions);

                const sizeRadio = this.variantFieldsets[0]?.querySelector('input[type="radio"]:checked');
                if (sizeRadio && sizeRadio.name === 'Size') {
                    const cachedFirstPart = sizeRadio.value.split('-')[0].toLowerCase().trim();
                    const cachedUpsellSelects = this.querySelectorAll('.upsell-select');
                    const cachedSelectOptions = Array.from(cachedUpsellSelects).map(select =>
                        Array.from(select.querySelectorAll('option'))
                    );
                    cachedUpsellSelects.forEach((select, index) => {
                        const selectOptions = cachedSelectOptions[index];
                        for (const option of selectOptions) {
                            if (option.text.toLowerCase().trim().includes(cachedFirstPart)) {
                                option.selected = true;
                                select.value = option.value;
                                select.dispatchEvent(new Event('change'));
                                break;
                            }
                        }
                    });
                }

                this.updateFinalVariant(combineVariant);
                this.updateRemainingOptions(radioBtnsChecked, allVariants);
                this.updateSizeOptionPrices(selectedOptions, allVariants);
            }, 0);
        }));

        const currentRadioBtnsChecked = this.getCheckedOptionRadios();
        const currentSelectedOptions = currentRadioBtnsChecked.map(btn => btn.value);
        this.updateRemainingOptions(currentRadioBtnsChecked);
        this.updateSizeOptionPrices(currentSelectedOptions);

        const variantSize = this.querySelector('.product-option-wrapper[data-fieldset-position="1"] .selected-option').textContent;
        // Use cached upsell popups
        if (!this.upsellPopups) {
            this.upsellPopups = this.querySelectorAll('.product-upsell-popup');
        }
        const upsellPopups = this.upsellPopups;

        upsellPopups.forEach(popup => {
            const variantSelect = popup.querySelector('.upsell-select');

            if (variantSelect) {
                let firstMatchFound = false;

                Array.from(variantSelect.options).forEach((option) => {
                    if (option.text.toLowerCase().includes(variantSize.toLowerCase())) {
                        if (!firstMatchFound) {
                            option.selected = true;
                            variantSelect.dispatchEvent(new Event('change'));
                            firstMatchFound = true;
                        }
                    }
                });
            }
        });
    }

    /**
     * Debounced URL update to prevent rapid-fire history changes
     * @param {number} variantId - The variant ID to update in URL
     */
    debouncedUrlUpdate(variantId) {
        if (this._urlUpdateTimeout) {
            clearTimeout(this._urlUpdateTimeout);
        }
        
        this._urlUpdateTimeout = setTimeout(() => {
            const url = new URL(window.location.href);
            url.searchParams.set('variant', variantId);
            history.replaceState(null, null, url.toString());
            this._urlUpdateTimeout = null;
        }, 300); // 300ms debounce
    }
}

customElements.define('product-section', ProductSection);